import {ValueObject} from '@s-ui/domain'

export class TokenRequestRatingsValueObject extends ValueObject {
  /**
   * @param {String} token
   */

  static validate({token, emptyTokenRatingsError}) {
    if (token === undefined) {
      throw emptyTokenRatingsError
    }
  }
}
